import RequestFormField from "./field"
import {BackGround} from "../../../../../core/gd-app/panels/preferences-panel/settings-background/settings-background"
import {RequestFormFieldType, RequestFormType} from "../../const/const"
import getMandatoryFormFields from "../../functions/get-mandatory-form-fields"
import ModelProxy from "../../../../../core/model2/model-proxy"
import {convertFromOldFormat} from "../functions/convert-from-old-format"
import {SharedViewLogoType} from "../../../../../core/modules/shared-views/types"
import RequestFormCrmIntegration from "./crm-integration";

const debug = false
// const debug = "RequestFormSettings"

export default class RequestFormSettings {

    fields              : RequestFormField[]

    color               : number                // form header and background color (REQUIRED)
    background          : BackGround // default... BackGround.GRAY
    logo                : SharedViewLogoType

    headerTitle         : string                // form header
    headerDescription   : string                // description in the header for the user filling out the form

    updatedFields       : Set<string>

    crmIntegration      : RequestFormCrmIntegration

    constructor(requestFormType: RequestFormType, data: any) {

        if (data.header) {
            data = convertFromOldFormat(data)
        }

        const mandatoryFormFields = getMandatoryFormFields(requestFormType)

        const fields            = _.map(_.get(data, 'fields', []), formFieldConfig=>{
            return new RequestFormField(formFieldConfig)
        })

        const presentMandatoryFields = _.filter(fields, requestFormField=>requestFormField.isMandatory)
        const missingMandatoryFields = _.differenceBy(mandatoryFormFields, presentMandatoryFields, requestFormField=>requestFormField.field?.fieldId)


        this.fields             = _.union(missingMandatoryFields, fields)

        // mandatory request form fields type fix
        _.map(this.fields, requestFormField=>{
            if (requestFormField.isMandatory && !requestFormField.taskFieldId) requestFormField.type = RequestFormFieldType.FORM
        })

        debug && console.log(debug, 'constructor', fields, mandatoryFormFields, presentMandatoryFields, missingMandatoryFields, this.fields)

        this.color              = _.get(data, 'color', 11)
        this.background         = _.get(data, 'background', BackGround.GRAY)
        this.logo               = _.get(data, 'logo', SharedViewLogoType.GOODDAY)

        this.headerTitle        = _.get(data, 'headerTitle', null)
        this.headerDescription  = _.get(data, 'headerDescription', null)

        this.crmIntegration     = new RequestFormCrmIntegration(_.get(data, 'crmIntegration', null))

        this.updatedFields      = new Set()

        return new Proxy(this, ModelProxy)
    }

    getExistingTaskFieldsIds = () => {
        return _.compact(_.map(this.fields, formField=>formField.taskFieldId))
    }

    addField(formField: RequestFormField) {
        this.fields.push(formField)
        this.updatedFields.add('fields')
    }

    updateField(formField: RequestFormField, data:any) {
        formField.applyDelta(data)
        this.updatedFields.add('fields')
    }

    removeField(formField: RequestFormField) {
        _.remove(this.fields, formField)
        this.updatedFields.add('fields')
    }

    toJSON(): JSONObject {
        return {
            fields              : _.map(this.fields, formField=>formField.toJSON()),
            color               : this.color,
            background          : this.background,
            logo                : this.logo,
            headerTitle         : this.headerTitle,
            headerDescription   : this.headerDescription,
            crmIntegration      : this.crmIntegration.toJSON()

        }
    }
}